import { UserManagementPage } from "pages/Users/UserManagementPage";
import { Redirect, Route, Switch } from "react-router-dom";

export const UserManagementRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/users" component={UserManagementPage} />
      <Redirect to="/pages" />
    </Switch>
  );
};
